import { Injectable } from '@angular/core';
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserAuthService } from '../services/user-auth.service';
import { Observable } from 'rxjs';
import { EncriptDecriptService } from '../services/encriptdecript';
@Injectable()
export class AuthGuard implements CanActivate {
    userDetail: any;
    userObj:any;
    constructor(public auth: UserAuthService, public router: Router,private encriptDecript:EncriptDecriptService)
     {
         this.userObj=this.encriptDecript.getLocalStorage('userObject');
         if(this.userObj!=null&& this.userObj!=undefined){
             this.userDetail = JSON.parse(this.userObj);
            }else{
                this.canActivate(); 
            } 
      }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if (this.auth.isAuthenticated()) {
            return this.checkPermisson();
        }
        else {
            this.router.navigate(['/login']);
            return false;
        }

    }

    checkPermisson(): boolean {
        this.userDetail ? this.userDetail : this.userDetail = undefined;
        if (this.userDetail.isAdmin != true) {
            return true;
        }
        else {
            this.router.navigate(['/login']);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/auth-guard.ts